import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';
import type { Metric } from 'web-vitals';

let initialized = false;

/**
 * Client-side real-user monitoring. Captures Web Vitals (LCP, INP, CLS,
 * FCP, TTFB) plus auth-flow performance marks and logs them to the
 * browser console. Developers pull logs from DevTools; a server sink
 * (POST /rum → CloudWatch) is intentionally deferred — console logs
 * plus `performance.getEntriesByType('measure')` in DevTools give us
 * enough signal to tune the next optimization without new infra.
 *
 * Guarded against double-registration so HMR or an accidental repeat
 * import won't fire duplicate metrics.
 */
export function initRum(): void {
  if (initialized) return;
  if (typeof window === 'undefined') return;
  initialized = true;
  const report = (metric: Metric): void => {
    const value = metric.name === 'CLS' ? metric.value.toFixed(3) : Math.round(metric.value);
    // eslint-disable-next-line no-console -- intentional: RUM is console-reported
    console.info(`[rum] ${metric.name}=${value} rating=${metric.rating} id=${metric.id}`);
  };
  onLCP(report);
  onINP(report);
  onCLS(report);
  onFCP(report);
  onTTFB(report);
}
